/**
 * DirhamSign — inline SVG of the UAE Dirham symbol (the new official
 * mark with the stylised "D" and two horizontal bars). Sized like an
 * inline-text character via `1em` so it scales with surrounding text.
 *
 * Why inline SVG vs Unicode (U+1ED36): the Dirham sign code point was
 * only added to Unicode 16 (2024), so most installed fonts still don't
 * have a glyph for it — users would see a tofu box. The inline SVG
 * renders consistently in every browser.
 *
 * Usage:
 *   <DirhamSign /> 1,250,000
 *   <p>Pipeline: <DirhamSign /> {value.toLocaleString()}</p>
 */

import React from 'react';

export default function DirhamSign({ size = '1em', className = '', title = 'AED' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      role="img"
      aria-label={title}
      // -0.1em baseline nudge so the symbol sits visually centred with
      // text x-height; without it the icon appears to "float" above
      // numerals at most sizes.
      style={{ display: 'inline-block', verticalAlign: '-0.1em' }}
      className={className}
    >
      <title>{title}</title>
      {/* D-shape body — vertical stem on the left and the rounded
          right side. The cut-out in the middle creates the inner
          counter. */}
      <path d="M5 4 H12.5 C17.7 4 21 7.7 21 12 C21 16.3 17.7 20 12.5 20 H5 V4 Z M8 7 V17 H12.5 C15.5 17 18 14.8 18 12 C18 9.2 15.5 7 12.5 7 H8 Z" />
      {/* Two horizontal bars crossing the body — set just under the
          middle to echo the official symbol's stroke positions. */}
      <rect x="3" y="10.4" width="19" height="1.3" />
      <rect x="3" y="13" width="19" height="1.3" />
    </svg>
  );
}
